import { post } from '@namespace/helpers';
import { IApiResponse } from '../../../types';

export const acceptJackpotWin = (
  jackpotId: number
): Promise<IApiResponse<null>> =>
  post(`/service/jackpot/api/jackpot/${jackpotId}/accept`);
